import React, { useState, useEffect, useRef } from 'react';
import './home.css';
import AboutMeImage from './Media/AboutMePreview.png';
import Oracle811Badge from './Media/Oracle811Badge.jpg';
import Oracle808Badge from './Media/Oracle808Badge.png';

import Contact from './contactDE';
import ResumePopup from './resumerequestDE';

// another comment because github V2

function Home() {
  const [language, setLanguage] = useState('en');
  const [showContactPopup, setShowContactPopup] = useState(false);
  const [showResumePopup, setShowResumePopup] = useState(false);
  const [clicked, setClicked] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [visibleSections, setVisibleSections] = useState({
    introduction: false,
    skills: false,
    experience: false,
    certifications: false,
    works: false,
    languages: false,
    aboutMe: false
  });

  // Refs for sections to track visibility
  const introductionRef = useRef(null);
  const skillsRef = useRef(null);
  const experienceRef = useRef(null);
  const certificationsRef = useRef(null);
  const worksRef = useRef(null);
  const languagesRef = useRef(null);
  const aboutMeSectionRef = useRef(null);
  const aboutImageRef = useRef(null); // Added ref for the flip card with your picture

  const handleClick = (index) => {
    setClicked(clicked === index ? null : index);
  };

  const handleContactClick = () => {
    setShowContactPopup(true);
  };

  const closeContactPopup = () => {
    setShowContactPopup(false);
  };

  const handleResumeClick = () => {
    setShowResumePopup(true);
  };

  const closeResumePopup = () => {
    setShowResumePopup(false);
  };

  // Function to check if an element is in viewport
  const isInViewport = (element, offset = 100) => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return (
      rect.top <= window.innerHeight - offset &&
      rect.bottom >= offset
    );
  };

  // Scroll listener effect
  useEffect(() => {
    const handleScroll = () => {
      // Update scroll position
      setScrollPosition(window.scrollY);
      
      // Check if each section is visible
      setVisibleSections({
        introduction: isInViewport(introductionRef.current),
        skills: isInViewport(skillsRef.current),
        experience: isInViewport(experienceRef.current),
        certifications: isInViewport(certificationsRef.current),
        works: isInViewport(worksRef.current),
        languages: isInViewport(languagesRef.current),
        aboutMe: isInViewport(aboutMeSectionRef.current)
      });

      // Navbar background change
      const navbar = document.querySelector('.Navbar');
      const scrollPercentage = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
    
      if (scrollPercentage >= 5) {
        navbar.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
        navbar.style.backdropFilter = 'blur(10px)';
        navbar.style.boxShadow = '0 4px 30px rgba(0, 0, 0, 0.1)';
      } else {
        navbar.style.backgroundColor = 'rgba(34, 34, 34, 0)';
        navbar.style.backdropFilter = 'none';
        navbar.style.boxShadow = 'none';
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // Initial check for visible sections
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToSection = (ref) => {
    if (ref.current) {
      // Get the element's position
      const yPosition = ref.current.getBoundingClientRect().top + window.pageYOffset;
      
      // Subtract a fixed offset (adjust the 80 value based on your navbar height plus desired padding)
      const offsetPosition = yPosition - 50;
      
      // Scroll to the adjusted position
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleRedirectEN = () => {
    window.location.href = '/'; // Redirect to the German version of the site
  };

  // Parallax effect for the about section
  const parallaxOffset = scrollPosition * 0.3;

  return (
    <div className="home-container">
      <div className='Navbar'>
        <div className='nav-button-container'>
          <h1 className='Name-Top-Left'>Ron <span className="name" onClick={() => scrollToSection(aboutImageRef)}>Ellrich</span></h1>
          <div className="nav-links">
            <button className='nav-button' onClick={handleContactClick}>Kontakt</button>
            <button className='nav-button' onClick={() => scrollToSection(worksRef)}>Projekte</button>
            <button className='nav-button' onClick={handleResumeClick}>Lebenslauf</button>
            <button className='nav-button' onClick={handleRedirectEN}>Sprache</button>
          </div>
        </div>
      </div>
  
      <div className="hero-section" style={{ transform: `translateY(${parallaxOffset}px)` }}>
        <div className="hero-content">
          <h1 className="hero-title">Fullstack Entwickler <br></br>&<br></br> Visueller Denker</h1>
          <p className="hero-subtitle">Ich gestalte Schnittstellen, und schärfe Pixel</p>
        </div>
      </div>
  
      <div className="about-section">
        <div className={`flip-card ${scrollPosition > 100 ? 'animate-in' : ''}`} ref={aboutImageRef}>
          <div className="flip-card-inner">
            <div className="flip-card-front">
              <img src={AboutMeImage} alt="Ron Ellrich" />
            </div>
            <div className="flip-card-back">
              <h2>Ron Ellrich</h2>
              <p>Ich Verwandle Ideen in Verträge,<br />und Verträge in Code.</p>
              <p>Code mit Stil • Design mit Herz</p>
              <p>Ansässig in Deutschland - Weltweit tätig</p>
              <p>☕ Kaffee. ⌨ Code. 🧠 Design.</p>
            </div>
          </div>
        </div>
  
        <div
          className={`Introduction ${visibleSections.introduction ? 'fade-in visible' : 'fade-in'}`}
          ref={introductionRef}
        >
          <h2>
            Hallo, ich bin <span className="name">Ron Ellrich</span>, UX/UI Designer und <br />
            Fullstack Entwickler mit Sitz in Deutschland.
          </h2>
        </div>
  
        <div
          className={`Lebenslauf Skills ${visibleSections.skills ? 'fade-in visible' : 'fade-in'}`}
          ref={skillsRef}
          id='TOP'
        >
          <h2 className="section-title">FÄHIGKEITEN</h2>
          <ul className="animated-list">
            <li
              onClick={() => handleClick(0)}
              className={`list-item ${clicked === 0 ? 'expanded' : ''}`}
            >
              {clicked === 0 ? (
                <div className="expanded-content">
                  <span>JavaScript, HTML5 und CSS3 werden zusammen verwendet, um interaktive, visuell ansprechende und responsive Websites und Webanwendungen zu erstellen...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">JavaScript</span> | <span className="highlight">HTML5</span> | <span className="highlight">CSS3</span> • Frontend Entwicklung
                </div>
              )}
            </li>
            <li
              onClick={() => handleClick(1)}
              className={`list-item ${clicked === 1 ? 'expanded' : ''}`}
            >
              {clicked === 1 ? (
                <div className="expanded-content">
                  <span>Mein aktuelles "Go-to" für die Webentwicklung. Ich liebe die Flexibilität und die Leistungsfähigkeit von React...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">React</span> • Frontend Framework
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(16)} 
              className={`list-item ${clicked === 16 ? 'expanded' : ''}`}
            >
              {clicked === 16 ? (
                <div className="expanded-content">
                  <span>Java wird für Unternehmenssoftware, die Entwicklung mobiler Apps, Web-Apps, Cloud-basierte Anwendungen, Spiele und IoT-Anwendungen verwendet...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <div className='Oracle811Badge'> <img src={Oracle811Badge} alt="Oracle Badge"/></div>
                  <div className='Oracle808Badge'> <img src={Oracle808Badge} alt="Oracle Badge"/></div>
                  <span className="highlight">Java</span> • Backend Entwicklung
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(21)} 
              className={`list-item ${clicked === 21 ? 'expanded' : ''}`}
            >
              {clicked === 21 ? (
                <div className="expanded-content">
                  <span>C# wird für Unternehmenssoftware, Desktop und Web-Apps, Spiel Entwicklung, und Cloud/Windows-basierte Anwendungen verwendet...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">C#</span> • Backend Development
                </div>
              )}
            </li>
            <li
              onClick={() => handleClick(2)}
              className={`list-item ${clicked === 2 ? 'expanded' : ''}`}
            >
              {clicked === 2 ? (
                <div className="expanded-content">
                  <span>Python wird für Backend-Entwicklung, Datenbanken, Analyse, Verarbeitung und mehr verwendet...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">Python</span> • Backend Entwicklung
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(22)} 
              className={`list-item ${clicked === 22 ? 'expanded' : ''}`}
            >
              {clicked === 22 ? (
                <div className="expanded-content">
                  <span>Spring Boot wird zur Entwicklung von unternehmensgerechten Backend-Systemen, REST-APIs, Microservices und cloudbasierten Anwendungen verwendet....</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">Spring Boot (Java)</span> • Backend Framework
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(23)} 
              className={`list-item ${clicked === 23 ? 'expanded' : ''}`}
            >
              {clicked === 23 ? (
                <div className="expanded-content">
                  <span>.NET ist eine plattformübergreifende Entwicklerplattform zur Erstellung von Web-, Mobil-, Desktop-, Spiele- und IoT-Anwendungen...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">.NET (C#)</span> • Entwicklungs Platform
                </div>
              )}
            </li>
            <li
              onClick={() => handleClick(3)}
              className={`list-item ${clicked === 3 ? 'expanded' : ''}`}
            >
              {clicked === 3 ? (
                <div className="expanded-content">
                  <span>DjangoDB wird verwendet, um Webanwendungen mit Fokus auf Backend-Entwicklung unter Verwendung von SQL-Datenbanken zu erstellen...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">DjangoDB (SQL | Python)</span> • Backend Framework
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(18)} 
              className={`list-item ${clicked === 18 ? 'expanded' : ''}`}
            >
              {clicked === 18 ? (
                <div className="expanded-content">
                  <span>MySQL ist ein relationales Datenbankmanagementsystem, das zum Speichern, Verwalten und Abfragen strukturierter Daten verwendet wird...</span>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">MySQL</span> • Datenbank Management System
                </div>
              )}
            </li>
          </ul>
        </div>
  
        <div
          className={`Lebenslauf Experience ${visibleSections.experience ? 'fade-in visible' : 'fade-in'}`}
          ref={experienceRef}
        >
          <h2 className="section-title">ERFAHRUNG</h2>
          <ul className="animated-list">
          <li 
              onClick={() => handleClick(19)} 
              className={`list-item ${clicked === 19 ? 'expanded' : ''}`}
            >
              {clicked === 19 ? (
                <div className="expanded-content">
                  <span>Weiterbildung als Softwareentwickler mit Schwerpunkt auf Java und C#, um mein Tech-Stack weiter auszubauen...</span>
                  <button className='Detail-Button' onClick={() => window.open('https://smartfuturecampus.de', '_blank')}>
                      Details
                    </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">Weiterbildung als Softwareentwickler - Java / C#</span> bei Smart Future Campus GmbH 2025 - 2026
                </div>
              )}
            </li>
            <li
              onClick={() => handleClick(4)}
              className={`list-item ${clicked === 4 ? 'expanded' : ''}`}
            >
              {clicked === 4 ? (
                <div className="expanded-content">
                  <span>Erfahrung als Customer Success Manager bei PAYZN GmbH, mit Fokus auf Kundenbeziehungen und Softwareentwicklung...</span>
                  <button className='Detail-Button' onClick={() => window.open('https://payzn.de', '_blank')}>
                    Details
                  </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">Customer Success Manager</span> bei PAYZN GmbH 2025 - 2025
                </div>
              )}
            </li>
            <li
              onClick={() => handleClick(5)}
              className={`list-item ${clicked === 5 ? 'expanded' : ''}`}
            >
              {clicked === 5 ? (
                <div className="expanded-content">
                  <span>Unterstützung im Hotelbetrieb - Rezeptions / Service / Beratungsarbeiten</span>
                  <button className='Detail-Button' onClick={() => window.open('https://www.hotel-kuestenperle.de', '_blank')}>
                    Details
                  </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">Ausbildung zum Hotelfachmann</span> in dem Küstenperle Strandhotel & Spa 2021 - 2024
                </div>
              )}
            </li>
          </ul>
  
          <h2
            className={`section-title ${visibleSections.certifications ? 'fade-in visible' : 'fade-in'}`}
            ref={certificationsRef}
          >
            ZERTIFIKATE
          </h2>
          <ul className="animated-list">
            <li 
              onClick={() => handleClick(20)} 
              className={`list-item ${clicked === 20 ? 'expanded' : ''}`}
            >
              {clicked === 20 ? (
                <div className="expanded-content">
                  <span>Branchenanerkannte Zertifizierung, die fundierte Kenntnisse in Java, OOP und praxisnaher Softwareentwicklung nachweist...</span>
                  <button className='Detail-Button' onClick={() => window.open('https://education.oracle.com/oracle-certified-associate-java-se-8-programmer/trackp_333', '_blank')}>
                      Details
                    </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <div className='Oracle808BadgeCertificate'> <img src={Oracle808Badge} alt="Oracle Badge"/></div>
                  <span className="highlight">Zertifizierter Associate, Java SE 8 Programmer</span>, ORACLE - 2025
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(15)} 
              className={`list-item ${clicked === 15 ? 'expanded' : ''}`}
            >
              {clicked === 15 ? (
                <div className="expanded-content">
                  <span>Branchenanerkannte Zertifizierung, die grundlegende Kenntnisse in Java, OOP und Softwareentwicklung nachweist... </span>
                  <button className='Detail-Button' onClick={() => window.open('https://education.oracle.com/oracle-certified-foundations-associate-java/trackp_372', '_blank')}>
                      Details
                    </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <div className='Oracle811Badge'> <img src={Oracle811Badge} alt="Oracle Badge"/></div>
                  <span className="highlight">Zertifizierter Foundations Associate in Java</span>, ORACLE - 2025
                </div>
              )}
            </li>
            <li 
              onClick={() => handleClick(17)} 
              className={`list-item ${clicked === 17 ? 'expanded' : ''}`}
            >
              {clicked === 17 ? (
                <div className="expanded-content">
                  <span>Staatlich anerkannte berufliche Kompetenz in der digitalen Informationstechnologie (Industrie und Handelskammer) </span>
                  <button className='Detail-Button' onClick={() => window.open('https://www.dihk-bildungs-gmbh.de/weiterbildung/ihk-zertifikate/zertifikatslehrgaenge/digitale-kompetenz-im-job-ihk', '_blank')}>
                      Details
                    </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">Digitale Berufskompetenz</span>, IHK - 2025
                </div>
              )}
            </li>
            <li
              onClick={() => handleClick(6)}
              className={`list-item ${clicked === 6 ? 'expanded' : ''}`}
            >
              {clicked === 6 ? (
                <div className="expanded-content">
                  <span>Staatlich anerkannter Hotelfachmann (Industrie und Handelskammer)</span>
                  <button className='Detail-Button' onClick={() => window.open('https://web.arbeitsagentur.de/berufenet/beruf/10009#ueberblick', '_blank')}>
                    Details
                  </button>
                </div>
              ) : (
                <div className="list-item-content">
                  <span className="highlight">IHK Zerifizierter Hotelfachmann</span>, Küstenperle Strandhotel & Spa - 2024
                </div>
              )}
            </li>
          </ul>
  
          <h2
            className={`section-title ${visibleSections.works ? 'fade-in visible' : 'fade-in'}`}
            ref={worksRef}
          >
            MEINE PROJEKTE
          </h2>
          <ul className="animated-list works-list">
            <li
              onClick={() => handleClick(7)}
              className={`list-item ${clicked === 7 ? 'expanded' : ''}`}
            >
              {clicked === 7 ? (
                <div className="expanded-content">
                  <span>Entwicklung eines Customer Resource Management Tools zur besseren Kundenbetreuung... (proprietäre Software)</span>
                </div>
              ) : (
                <div className="list-item-content">Customer Resource Management Tool (CRM)</div>
              )}
            </li>
            <li
              onClick={() => handleClick(8)}
              className={`list-item ${clicked === 8 ? 'expanded' : ''}`}
            >
              {clicked === 8 ? (
                <div className="expanded-content">
                  <span>Integration vieler E-Commerce-API-Endpunkte zur Erleichterung von Produktmanagement, Finanzen, Abrechnung... (proprietäre Software)</span>
                </div>
              ) : (
                <div className="list-item-content">E-Commerce-API-Endpunktintegration</div>
              )}
            </li>
            <li
              onClick={() => handleClick(9)}
              className={`list-item ${clicked === 9 ? 'expanded' : ''}`}
            >
              {clicked === 9 ? (
                <div className="expanded-content">
                  <span>Entwicklung eines Discord-Bots mit API-Integration zur Verwaltung von Community-Interaktionen... (temporär proprietäre Software)</span>
                </div>
              ) : (
                <div className="list-item-content">Discord-Bot mit API-Integration</div>
              )}
            </li>
            <li
              onClick={() => handleClick(10)}
              className={`list-item ${clicked === 10 ? 'expanded' : ''}`}
            >
              {clicked === 10 ? (
                <div className="expanded-content">
                  <span>Erstellung privater Websites, die auf Kundenbedürfnisse zugeschnitten sind, mit benutzerdefinierten Funktionen / Datenbanken / Design...</span>
                </div>
              ) : (
                <div className="list-item-content">Private Websites auf Anfrage</div>
              )}
            </li>
            <li
              onClick={() => handleClick(11)}
              className={`list-item ${clicked === 11 ? 'expanded' : ''}`}
            >
              {clicked === 11 ? (
                <div className="expanded-content">
                  <span>Erstellung einer Portfolio-Website zur Präsentation von Fähigkeiten und Arbeiten...</span>
                </div>
              ) : (
                <div className="list-item-content">Portfolio-Website</div>
              )}
            </li>
          </ul>
  
          <h2
            className={`section-title ${visibleSections.languages ? 'fade-in visible' : 'fade-in'}`}
            ref={languagesRef}
          >
            SPRACHEN
          </h2>
          <ul className="animated-list languages-list">
            <li
              onClick={() => handleClick(12)}
              className={`list-item ${clicked === 12 ? 'expanded' : ''}`}
            >
              {clicked === 12 ? (
                <div className="expanded-content">
                  <span>Muttersprachler Deutsch...</span>
                </div>
              ) : (
                <div className="list-item-content">Deutsch (Muttersprache)</div>
              )}
            </li>
            <li
              onClick={() => handleClick(13)}
              className={`list-item ${clicked === 13 ? 'expanded' : ''}`}
            >
              {clicked === 13 ? (
                <div className="expanded-content">
                  <span>Fließend Englisch, fähig zur effektiven Kommunikation in internationalen Umgebungen...</span>
                </div>
              ) : (
                <div className="list-item-content">Englisch (Fließend)</div>
              )}
            </li>
            <li
              onClick={() => handleClick(14)}
              className={`list-item ${clicked === 14 ? 'expanded' : ''}`}
            >
              {clicked === 14 ? (
                <div className="expanded-content">
                  <span>Fließend Russisch, Muttersprache...</span>
                </div>
              ) : (
                <div className="list-item-content">Russisch (Muttersprache)</div>
              )}
            </li>
          </ul>
        </div>
      </div>
  
      <div className={`AboutMeSection ${visibleSections.aboutMe ? 'fade-in visible' : 'fade-in'}`}
        ref={aboutMeSectionRef}
      >
        <h2 className="section-title about-me-title">Von der Hotellerie zum Code - Der Mensch steht immer noch im Mittelpunkt</h2>
        <p className="about-me-text">Aus einem Hintergrund im Hotelmanagement kommend, entdeckte ich meine wahre Leidenschaft in der Welt des Codes.
          Aber ich habe nie vergessen, was mir die Gastronomie beigebracht hat - wie man zuhört, wie man versteht und wie man Erlebnisse liefert, die wirklich ankommen.
          Heute schlage ich die Brücke zwischen Kunden und Code. Ich baue nicht nur, was angefordert wird - ich stelle sicher, dass die Vision des Kunden richtig übersetzt wird:
          mit Klarheit, Empathie und Präzision. Ob es sich um eine Funktion, ein Produkt oder ein vollständiges digitales Erlebnis handelt,
          ich bringe sowohl menschliches Verständnis als auch technische Ausführung mit ein.</p>
  
        <div className="contact-button-container">
          <p className="contact-prompt">Habe ich Ihr Interesse geweckt?</p>
          <button className="glow-button" onClick={handleContactClick}>
            Kontaktieren Sie mich, ich melde mich so schnell wie möglich bei Ihnen
          </button>
        </div>
      </div>
  
      <footer className="footer">
        <div className={`footer-content ${scrollPosition > (document.documentElement.scrollHeight - window.innerHeight - 300) ? 'fade-in visible' : 'fade-in'}`}>
          <p>© 2026 Ron Ellrich | Fullstack Entwickler & UX/UI Designer</p>
          <button className="scroll-to-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            ↑
          </button>
        </div>
      </footer>
  
      {/* Popup Modal for Contact Form */}
      {showContactPopup && (
        <div className="popup-overlay contact-popup-overlay">
          <div className="popup contact-popup">
            <button className="close-popup" onClick={closeContactPopup}>X</button>
            <Contact />
          </div>
        </div>
      )}
  
      {/* Popup Modal for Resume Request */}
      {showResumePopup && (
        <ResumePopup onClose={closeResumePopup} />
      )}
    </div>
  );
}

export default Home;